import React from 'react';

const TemplateCard = ({ name, type, onSelect, TemplateComponent }) => {
  return (
    <div 
      onClick={() => onSelect(type)}
      className="group cursor-pointer w-full bg-white rounded-xl 
                 shadow-sm hover:shadow-xl transition-all duration-300 
                 border border-gray-200 overflow-hidden flex flex-col h-[280px]" // Total height kam ki hai
    >
      {/* 1. Preview Container: Isse flex-1 kiya hai taaki ye bachi hui saari jagah lele */}
      <div className="relative flex-1 bg-[#fcfcfc] overflow-hidden flex justify-center border-b border-gray-100">
        
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/5 group-hover:bg-transparent 
                        transition-colors z-20 pointer-events-none" />

        {/* 2. Scaling Wrapper: Center alignment aur top padding fix ki hai */}
        <div className="absolute top-2 w-[500px] origin-top scale-[0.38] shadow-lg z-10">
          <div className="bg-white min-h-[700px] w-full border border-gray-100">
            <div className="w-full overflow-hidden">
                <TemplateComponent data={{}} />
            </div>
          </div>
        </div>
      </div>
      
      <div className="px-4 py-2 bg-white flex justify-between items-center shrink-0">
        <span className="font-bold text-gray-700 text-[10px] sm:text-[11px] truncate uppercase tracking-tighter">
          {name}
        </span>
        <div className="text-blue-600">
          <svg 
            className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" 
            fill="none" stroke="currentColor" viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" 
                  d="M17 8l4 4m0 0l-4 4m4-4H3" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default TemplateCard;